import { takeLatest, call, put, all, delay } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_AAC_API } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';
import handleFailed from 'utils/getValidations';

// ACTIONS
import { setLoader } from 'store/modules/app/loader/actions';
import {
	emissaoAtestadoAntecedentesSuccess,
	emissaoAtestadoAntecedentesFailure,
} from './actions';

// TYPES
import { Types, RequestEmissaoAtestadoAntecedentes } from './types';
import { baixarArquivosRequest } from '../../utils/arquivos/baixarArquivos/actions';

export const allowedAACErrorCodes = ['CO6', 'CO1', 'CO2', 'C13', 'C17', 'C89'];

function* consultaAtestadoNumeralRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: RequestEmissaoAtestadoAntecedentes } = request;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_AAC_API,
		`v3/criminal-completa`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		if (response.data && response.data.pdfDataUrl) {
			setLoader(true);
			yield delay(3000);
			yield put(
				baixarArquivosRequest(token || '', {
					url: response.data.pdfDataUrl,
					instanceRequest: 'aac',
				}),
			);
		}
		yield put(emissaoAtestadoAntecedentesSuccess(response.data));
	} else if (
		(response.data?.status === 400 || response.data?.status === 404) &&
		response.data?.data?.codigoRetorno &&
		allowedAACErrorCodes.includes(response.data.data.codigoRetorno)
	) {
		yield put(
			emissaoAtestadoAntecedentesSuccess({
				pdfBase64: '',
				nomeSocial: '',
				codigo: response.data?.data?.codigoRetorno,
				mensagem: response.data?.data?.messages,
			}),
		);
	} else if (response) {
		handleFailed({
			mensagem_erro: response.data?.data?.messages,
		});
		yield put(emissaoAtestadoAntecedentesFailure());
	}
}

export default all([
	takeLatest(
		Types.EMISSAO_ATESTADO_ANTECEDENTES_REQUEST,
		consultaAtestadoNumeralRequest,
	),
]);
